<template>

<div class="avatar" v-tooltip="tooltipText" v-on:click="onClick" v-bind:style="{backgroundImage: backgroundImage, backgroundColor: backgroundColor}" v-bind:class="{'is-clickable': type === 'user' || (type === 'player' && !notLinked)}">

	<div class="avatar-initial" v-if="backgroundImage === 'none' || !backgroundImage">{{ initial }}</div>

	<slot></slot>

</div>

</template>

<script>

export default {

	props: ['type', 'id', 'tooltip', 'item', 'tooltipName', 'notLinked', 'tooltipSmall', 'size', 'overrideClick'],

	data: function() {

		return {
			source: false,
			initial: '',
			primaryname: '',
			secondaryname: '',
			slug: '',
			backgroundColor: false,
			backgroundImage: false
		}

	},

	created: function() {

		if (this.type === 'context') {

			this.$watch(function() {

				return this.$store.getters['context/id']

			}, function() {

				this.onChange()

			})

		} else {

			this.$watch(function() {

				return this.idFinal

			}, function() {

				this.onChange()

			})

		}

		this.onChange()

	},

	computed: {

		idFinal: function() {

			return (this.item) ? this.item.id : this.id

		},

		tooltipText: function() {

			if (this.type === 'player') {

				if (this.notLinked) {

					return false

				} else {

					return (this.tooltipName) ? this.primaryname + '<small>Click to view player profile</small>' : 'Click to view player profile'

				}

			} else if (this.tooltip) {

				var html = []

				html.push(this.primaryname)

				if (this.secondaryname) html.push('<small>' + this.secondaryname + '</small>')
				if (this.tooltipSmall) html.push('<small>' + this.tooltipSmall + '</small>')

				return html.join('')

			} else {

				return false

			}

		}

	},

	methods: {

		onChange: function() {

			if (this.type === 'context') this.source = this.$store.getters['context']
			if (this.type === 'session' && this.loggedin) this.source = this.$store.getters['session']
			if (this.type === 'game') this.source = this.$store.getters['data/games'][this.idFinal]
			if (this.type === 'user') this.source = this.$store.getters['data/users'][this.idFinal]
			if (this.type === 'player' && this.idFinal) this.source = this.$store.getters['data/users'][this.idFinal]
			if (this.type === 'group') this.source = this.$store.getters['data/groups'][this.idFinal]
			if (this.type === 'session' && !this.loggedin) {

				this.source = {
					name: 'guest',
					avatar: ''
				}

			}
			if (this.type === 'player' && !this.idFinal) {

				this.source = {
					name: (this.item) ? this.item.name : 'Player',
					slug: this.item.slug,
					avatar: ''
				}

			}
			if (this.type === 'player' && this.idFinal) {

				this.source.name = this.item.name || this.source.name
			}

			this.initial = ''
			this.primaryname = ''
			this.secondaryname = ''
			this.slug = ''
			this.backgroundColor = false
			this.backgroundImage = false

			if (this.source) {

				if (this.type === 'user') {

					this.primaryname = this.source.fullname || this.source.name
					this.secondaryname = (this.source.fullname) ? this.source.name : ''

				} else {

					this.primaryname = this.source.name

				}

				var parts = this.primaryname.split(' ')

				var initials = []

				this.$_.each(parts, function(part) {

					initials.push(part.replace(/[^\p{L}]/gu, "").charAt(0))

				})

				if (initials.length > 2) initials = initials.slice(0, 2)

				this.initial = initials.join('').toUpperCase()

				this.slug = this.source.slug

				if (this.source.avatar && this.type !== 'game') {

					if (this.source.avatar) {

						if (this.type === 'user' || this.type === 'session' || (this.type === 'context' && this.$store.getters['context/type'] === 'users')) {

							this.backgroundImage = this.$CONSTANTS.ASSETS + '/api/users/avatar/' + this.source.id

						} else {

							this.backgroundImage = this.source.avatar

						}

					}

				} else {

					if (this.type === 'game') {

						this.backgroundImage = this.$util.thumbnail.game[(this.size) ? this.size : 'small'](this.source || this.idFinal)

					}

				}

				if (!this.backgroundImage && this.type !== 'game') {

					var type

					if (this.type === 'context') type = this.$store.getters['context/type']
					if (this.type === 'session') type = this.$CONSTANTS.TYPE.USERS
					if (this.type === 'user') type = this.$CONSTANTS.TYPE.USERS
					if (this.type === 'player') type = this.$CONSTANTS.TYPE.USERS

					if (this.source && !this.$store.getters['util/colors/' + type][this.slug]) {

						this.$store.commit('util/colors/assign', {
							type: type,
							name: this.slug,
							initial: this.initial
						})

					}

					this.backgroundColor = (this.source) ? this.$store.getters['util/colors/' + type][this.slug] : ''

				}

				if (this.backgroundImage) {

					this.backgroundImage = 'url(' + this.backgroundImage + ')'

				} else {

					this.backgroundImage = 'none'

				}

			}

		},

		onClick: function(e) {

			if (this.type === 'user' && !this.overrideClick) {

				this.$routerPush({
					name: 'Collection',
					params: {
						type: 'users',
						name: this.slug
					}
				}).catch(function() { })

			} else if (this.type === 'game' && e.shiftKey) {

				this.$util.bgg.open.game(this.idFinal)

			} else {

				this.$emit('click')

			}

		}

	}

}

</script>

<style scoped>

.avatar {
	position: relative;
	background-position: 50% 50%;
	background-size: cover;
	background-color: #fff;
	font-weight: 500;
	border-radius: 4px;
}

.avatar.is-clickable {
	cursor: pointer;
}

.avatar-initial {
	position: absolute;
	left: 50%;
	top: 50%;
	font-size: 16px;
	text-transform: uppercase;
	transform: translate(-50%, -50%);
	color: #fff;
}

</style>
